// TABLE_NAME: PlanesEstrategicosDetallesCamposTiposDatos
export const NUMBER = 1;
export const SHORT_TEXT = 2;
export const LONG_TEXT = 3;
export const BOOLEAN = 4;
export const OPTIONS = 5;
